import { FC } from "react";
import { ChatServerButton, ChatServerListItem } from "../../xapp/ChatServerMessage";
import { ActionItemImage } from "../ActionItem";
import { ActionItem } from "../ActionItem/ActionItem";
import { ChatActionButtons } from "../ChatActionButtons";
import "./CarouselItem.scss";
import { OpenUrlCallback } from "../../hooks/useOpenUrlCallback";

export interface CarouselItemProps {
    readonly item: ChatServerListItem;
    readonly emptyImageVisible?: boolean;
    onButtonClick(button: ChatServerButton): void;
    onExecute(text: string, token?: string): void;
    onOpenUrl: OpenUrlCallback;
}

const CarouselItem: FC<CarouselItemProps> = (props) => {
    const { item } = props;

    return (
        <ActionItem
            className="chat-list-item-container"
            item={item}
            onButtonClick={props.onButtonClick}
            onExecute={props.onExecute}
            onOpenUrl={props.onOpenUrl}>
            <div className="chat-list-item">
                <ActionItemImage
                    item={item}
                    className="chat-list-item__img"
                    emptyImageVisible={props.emptyImageVisible}
                />
                {item.title && (
                    <div className="chat-list-item__title">
                        <span>{item.title}</span>
                    </div>
                )}
                {item.subTitle && (
                    <div className="chat-list-item__subtitle">
                        <span>{item.subTitle}</span>
                    </div>
                )}
                {!!item.buttons?.length && (
                    <ChatActionButtons
                        className="chat-list-item__actions"
                        buttons={item.buttons}
                        onClick={props.onButtonClick}
                    />
                )}
            </div>
        </ActionItem>
    );
};

export default CarouselItem;
